/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DrawDetailsMasterInfo } from '../../../resources/draw-details.model';
import { ContactDetailsDialogConfig, contactDetailsDialogRoute } from '@gh/builder-shared';
import { ContactType } from '@gh/builder-shared-data';
import { filter$ } from '@gh/rx/operators';
import { DialogService } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-draw-details-job-form',
  templateUrl: 'draw-details-job-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawDetailsJobFormComponent {
  @Input() editable: boolean;
  @Input() job?: DrawDetailsMasterInfo;

  @Output() search = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();

  constructor(private dialogService: DialogService) {
  }

  openContact(): void {
    this.dialogService.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: this.job?.customerId,
      parentTitle: 'lbl_job',
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => {
// @ts-expect-error Legacy typing suppression
        this.job.customerId = contact.contactId;
// @ts-expect-error Legacy typing suppression
        this.job.customerName = contact.name;
      });
  }
}
